import axios from 'axios';
import { config } from '../../config';
import { adminAuthHeaders } from './authHeaders';

export async function getIsAdmin() {
    const host = `${config.service.host}/api/admin`;
    const headers = await adminAuthHeaders({ forceRefresh: true });
    const { data } = await axios.get(`${host}/me`, {
        headers,
    });
    return data;
}
